export default "__VITE_ASSET__BXEQ5aIc__"